import React from "react";

// value: {list, isLoad, currentPage, lastPage, total, setPage, sortKey, sortIsAsc, setSort,
//         header, renderRow, filters, onApplyFilters, onResetFilters,
//         refreshInterval, setRefreshInterval, reload}
export const ContextList = React.createContext(null);
